import {provideMissingTranslationHandler, TranslateLoader} from "@ngx-translate/core";
import {EmptyMissingTranslationHandler} from "@app/translate/empty-missing-translation-handler.service";
import {HttpClient} from "@angular/common/http";
import {CustomTranslateLoader} from "@app/translate/custom-translate-loader.service";

export const TranslationConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: (http: HttpClient) => new CustomTranslateLoader(http),
    deps: [HttpClient]
  },
  lang: 'en',
  supportedLanguages: ['ru', 'en'],
  missingTranslationHandler: provideMissingTranslationHandler(EmptyMissingTranslationHandler)
}
